module.exports = __webpack_public_path__ + "img/Flag_of_Saint_Lucia.f339668e.svg";